import auth from "@/store/auth";
import external from "@/gavnoCode/external";
import errorHandlerExternal from "@/plugins/errorHandlerExternal";
import router from "@/router";

/**
 * Уникальная константная метка для быстрого поиска по проекту (grep '#Z9K4').
 * Показывается пользователю в alert при сбое загрузки массива доступов.
 * @type {string}
 */
export const ACCESS_LOAD_ERROR_TAG = '#Z9K4';

/**
 * кэш промиса загрузки: доступы грузим один раз за сессию.
 * При ошибке кэш сбрасывается, чтобы следующая навигация могла повторить попытку.
 * @type {Promise|null}
 */
let loadPromise = null;

/**
 * Сам запрос массива доступов (web-объекты пользователя) и запись в стор.
 * Намеренно НЕ трогаем глобальный лоудер (auth.isLoading): это инфраструктурная
 * фоновая загрузка в router guard, а общий флаг - булев и разделяемый ~240 компонентами,
 * поэтому участие в нём приводит к гонкам (преждевременное гашение чужого спиннера).
 * @returns {Promise<Array>}
 */
const fetchAccess = async () => {
    const res = await external.universalRequest({
        externalType: 'ms',
        msUrl: 'accessnp/CotrollerRole/getWebObjectsByUserID',
        urlType: '',
        method: 'GET',
    });
    // защита от "успех, но формат не согласован": HTTP-200, но Data не массив.
    // трактуем как сбой -> та же ветка reject (сброс кэша в ensureLoaded + обработка в router #Z9K4),
    // и accessArray гарантированно остаётся валидным массивом (downstream accessSearch/findIndex не упадёт).
    if (!Array.isArray(res)) {
        throw external.errorDigestion(97, 'getWebObjectsByUserID: ожидался массив доступов, получено ' + (res === null ? 'null' : typeof res));
    }
    for (let i = 0; i < res.length; i++) {
        res[i]['show'] = false;
    }
    auth.mutations.saveAccessArray(auth.state, res);
    return res;
};

export default {
    ACCESS_LOAD_ERROR_TAG,
    /**
     * Гарантирует загрузку массива доступов (один раз за сессию).
     * Использовать в router.beforeEach: await ensureLoaded().
     * @returns {Promise<Array>}
     */
    ensureLoaded() {
        if (loadPromise) {
            return loadPromise;
        }
        loadPromise = fetchAccess().catch((err) => {
            loadPromise = null; // разрешаем повторную попытку на следующей навигации
            throw err;
        });
        return loadPromise;
    },
    /**
     * Обратная совместимость: разовое получение доступов с обработкой ошибки на месте
     * (используется в detailULG.vue). Ошибку глотает через errorHandlerExternal.
     */
    getAccess() {
        return this.ensureLoaded().catch((res) => {
            errorHandlerExternal(res, router, 'checkAccess');
        });
    },
}
